import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconProductBulkDisbursement = createIcon({
  viewBox: '0 0 56 56',
  path: (
    <>
      <path
        d="M35.5131 37.0853C32.4327 40.171 28.2674 41.9291 23.9077 41.9838H23.8189C20.4066 41.6468 17.2173 40.1351 14.796 37.7072L13.0194 35.9305L2.48638 25.4102C2.38835 25.3115 2.33333 25.1781 2.33333 25.039C2.33333 24.8999 2.38835 24.7665 2.48638 24.6678L2.96861 24.1792C5.8563 21.2937 9.77153 19.6729 13.8538 19.6729C17.936 19.6729 21.8513 21.2937 24.739 24.1792L36.1857 35.6704C36.2837 35.769 36.3387 35.9025 36.3387 36.0416C36.3387 36.1806 36.2837 36.3141 36.1857 36.4127L35.5131 37.0853Z"
        fill="#006DB8"
      />
      <path
        style={{ mixBlendMode: 'multiply' }}
        d="M36.5537 36.0446L35.5131 37.0852C32.4175 40.1867 28.2262 41.9462 23.8443 41.9837C20.4163 41.6518 17.2107 40.1375 14.777 37.7007L13.0004 35.924L24.7199 24.1791L29.9928 18.9062C31.5467 17.3509 33.3919 16.117 35.423 15.2751C37.4541 14.4333 39.6311 14 41.8297 14C44.0283 14 46.2054 14.4333 48.2365 15.2751C50.2675 16.117 52.1127 17.3509 53.6667 18.9062L36.5537 36.0446Z"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="13.0004"
          y1="28.0052"
          x2="53.6667"
          y2="28.0052"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B3E2ED" />
          <stop offset="0.41" stopColor="#0DBCE8" />
        </linearGradient>
      </defs>
    </>
  ),
});

export default IconProductBulkDisbursement;
